
import { Component, Prop, Vue } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface from '@/services/Internal-Tickets/interfaces';

@Component({
  inject: ['internalTicketsRepository'],
})
export default class NoteComponent extends Vue {

  @Prop() notes: any[];
  @Prop() ticketId: string;
  @Prop() isVisible: boolean;
  public noteInput: string = '';

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  public async addNote() {
    await this.internalTicketsRepository.createNote(Number(this.ticketId), { message: this.noteInput });
    this.noteInput = ''
  }
}

